import ContentPage from '../../content/ContentPage';
import createMemoizer from '../../core/dashboard/createMemoizer';
import { selectCollection } from '../../resources/selectors';
import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { RootState } from '../../resources/reduxTypes';
import {
  Configuration, EditableResourceFields, Page,
} from '../../resources/modelTypes';

export type WebsiteCustomPageProps = {
  configuration: Configuration
  id: string,
  pageData: Page,
  title: string,
}

type WebsiteCustomPagePropsWithRedux = {
  sections: EditableResourceFields[],
} & WebsiteCustomPageProps;

const WebsiteCustomPage = ({
  configuration,
  id,
  pageData,
  sections,
  title,
}: WebsiteCustomPagePropsWithRedux) => {
  const sortedSections = useMemo(
    () => sections.sort(
      (sectionA, sectionB) => sectionA.position - sectionB.position,
    ),
    [
      sections,
    ],
  );

  return (
    <ContentPage
      configuration={configuration}
      data={sortedSections}
      id={id}
      pageData={pageData}
      title={title}
    />
  );
};

const memoizeSections = createMemoizer();

const mapStateToProps = (state: RootState, props: WebsiteCustomPageProps) => {
  const sections: EditableResourceFields[] = memoizeSections(
    selectCollection(state.resources.sections, {
      page: props.pageData.id,
    }).items.map((section) => ({
      // Map from content to description, so the rich text renders
      ...section.data,
      description: section.data.content,
    })),
  );

  return {
    sections,
  };
};

// @ts-expect-error Force types for redux/react connection
export default connect(mapStateToProps)(WebsiteCustomPage) as React.FC<WebsiteCustomPageProps>;
